import { TimeSeries, DateHelper, AlignMethod } from "../../common/src";

const { timestampToComparable } = DateHelper;

export default function portfolioFromFundInfo(data) {
    const fundClass = data.classes.find((d) => d.shareClass === "C");
    const benchmark = data.benchmarks[0];
    const returnTimeSeries = TimeSeries.fromJson(fundClass.returnTimeSeries);
    const end = [returnTimeSeries.end as Date];
    const portf = {
        name: data.name,
        returnTimeSeries,
        benchmarkName: benchmark.longName,
        benchmarkTimeSeries: TimeSeries.fromJson(benchmark.returnTimeSeries),
        valueTimeSeries: new TimeSeries(end, [data.navValue])
    };

    if (benchmark.instrumentCurrency !== fundClass.navCurrency) {
        const fxName = benchmark.instrumentCurrency + fundClass.navCurrency;
        const fxRates = data.fxRates.find((d) => d.name === fxName);
        if (fxRates) {
            const bmts = portf.benchmarkTimeSeries;
            let fxts = TimeSeries.fromJson(fxRates);
            if (timestampToComparable(bmts.start) < timestampToComparable(fxts.start)) {
                const start = bmts.start;
                fxts.__dates.unshift(start as any);
                fxts.__values.unshift(bmts.startValue);
            }
            fxts = TimeSeries.align(bmts, fxts, AlignMethod.Latest);
            portf.benchmarkTimeSeries = bmts.mult(fxts);
        }
    }
    return portf;
}
